export default function LeadsHero() {
  return (
    <section className="relative bg-gradient-to-br from-emerald-600 via-teal-600 to-cyan-600 text-white py-20">
      <div className="absolute inset-0 bg-black/20"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 text-center">
        <div className="w-20 h-20 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center mx-auto mb-6">
          <i className="ri-customer-service-2-line text-5xl text-white"></i>
        </div>
        
        <h1 className="text-5xl md:text-6xl font-bold mb-6">
          Get Free Quotes from Local Pros
        </h1>
        
        <p className="text-xl md:text-2xl text-white/90 mb-8 max-w-3xl mx-auto">
          Connect with trusted service providers in Roseville. Compare quotes, read reviews, and hire with confidence.
        </p>
        
        <div className="flex flex-wrap gap-4 justify-center items-center">
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-shield-check-line text-2xl"></i>
            <span className="font-semibold">Verified Providers</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-time-line text-2xl"></i>
            <span className="font-semibold">Fast Response</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 backdrop-blur-sm px-6 py-3 rounded-full">
            <i className="ri-money-dollar-circle-line text-2xl"></i>
            <span className="font-semibold">100% Free</span>
          </div>
        </div>
      </div>
    </section>
  );
}